import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "./Login";
import {Button, Card, Popconfirm, Table} from "antd";
import Colors from "../../styles/Colors";
import Ingredient from "../../model/menudesign/Ingredient";
import {BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import AlergensModal from "../root/component/AlergensModal";
import PlantillaLista from "../PlantillaLista";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import {Dayjs} from 'dayjs';
import {GetComandesGeneradesIdPdf} from "../../dao/menudesign/comandes/GetComandesGeneradesIdPdf";
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {GetAlergens} from "../../dao/inscripcions/GetAlergens"
import { DeleteAlergens } from '../../dao/alergens/DeleteAlergens';
import Alergen from '../../model/inscripcions/Alergen';

const Alergens = () => {
    const titol: string = "Gestió d'Al·lèrgens";
    const nomPermis: string = "Alergens";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<any[]>([]);
    const [elementSelected, setElementSelected] = useState<Alergen>(new Alergen());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());


    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetAlergens(page);
        setDades(dades);
        await setNameFilters(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        await DeleteAlergens(id, page);
        await checkDades();
    }

    function afegirElement(element: Alergen) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElement(element: Alergen, edit: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }

    async function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
        await checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Alergen[]) {
        const alergensNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(alergensNames);
    }

    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    /**
     * --- FILTRES ----
     **/

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {/* {permisosEdicio && ( */}
                        <>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElement(ele, true)}><BiPencil/></Button>
                            {" "}
                            <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteElement(ele.id)}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>
                            {" "}
                        </>
                    {/* )} */}
                    <Button title={"Mostrar"} onClick={() => togleNouElement(ele, false)}
                            style={{backgroundColor: Colors.colors.color4}}><BsEye/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<any> = {
        loading
    };


    function modificarDatosForm() {
        //form.setFieldsValue({ remesa: 0 });
    }

    const onChange: TableProps<any>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: Ingredient) => {
        return (
            <PlantillaLista element={ele}/>
        );
    };

    async function handleDownload (id: string)  {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    function nouAlergen() {
        setEditar(true);
        afegirElement(new Alergen());
    }

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {/* {permisosEdicio && */}
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    nouAlergen()}><BiPlus/></Button>
                           {/*  } */}
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                rowKey="id"
                                columns={columns}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={coleccio}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={titol} pagina={page}/>
                    {nouElement && (
                        <AlergensModal element={elementSelected} onClose={handleCloseModal} visible={nouElement} editar={editar} page={page}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Alergens;
